import React from "react";
import { useIntl } from "react-intl";
import { PeekButton, PeekDivider, PeekStack, PeekTooltip, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "../messages.i18n";
export const CustomSubtopicsFooter = ({ onSave, unsavedChangesCount, readOnly, hasBeenRun, }) => {
    const intl = useIntl();
    const disabled = readOnly || hasBeenRun;
    return (React.createElement(PeekStack, null,
        React.createElement(PeekDivider, { light: true }),
        React.createElement(PeekStack, { alignItems: "center", sx: { p: 2 }, spacing: 1 },
            unsavedChangesCount > 0 && !disabled && (React.createElement(PeekTypography, { variant: "h4", color: "error.main", fontWeight: "fontWeightMedium" }, intl.formatMessage(messages.unsavedChanges, { count: unsavedChangesCount }))),
            React.createElement(PeekTooltip, { title: readOnly ? (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.upgradeToPremiumTooltip))) : hasBeenRun ? (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.hasBeenRunTooltip, {
                    bold: (chunks) => React.createElement("span", { style: { fontWeight: 500 } }, chunks),
                    br: () => React.createElement("br", null),
                }))) : ("") },
                React.createElement("span", null,
                    React.createElement(PeekButton, { variant: "contained", color: "primary", size: "large", onClick: onSave, disabled: disabled }, intl.formatMessage(messages.saveAndApplyButton)))))));
};
